import { ArticleVersionChannel, ArticleVersionData } from "../types/ArticleVersion";

import { isKeyUpdated } from "./updateArticleChannelDeliveryNeeded";

const { channels, ...articleShape } = ArticleVersionData.shape;
const channelShape = ArticleVersionChannel.shape;

export default function getArticleVersionData(articleBefore, articleAfter) {
	const before = pickVersionData(articleBefore);
	const after = pickVersionData(articleAfter);

	const channelIds = [...new Set([...Object.keys(before.channels), ...Object.keys(after.channels)])];

	const updated =
		isAnyKeyUpdated(articleShape, before, after) ||
		channelIds.some((channelId) =>
			isAnyKeyUpdated(channelShape, before.channels[channelId], after.channels[channelId]),
		);

	return updated ? { before, after } : null;
}

function pickVersionData(article) {
	return {
		...pick(articleShape, article),
		channels: Object.fromEntries(
			Object.entries(article.channels || {}).map(([channelId, channel]) => [
				channelId,
				pick(channelShape, channel),
			]),
		),
	};
}

function pick(shape, object) {
	return Object.fromEntries(
		Object.entries(shape)
			.map(([key, type]) => {
				const result = type.safeParse(object?.[key]);

				return [key, result.success ? result.data : object?.[key]];
			})
			.filter(([, value]) => value !== undefined),
	);
}

function isAnyKeyUpdated(shape, before, after) {
	return Object.keys(shape).some((key) => isKeyUpdated(key, before?.[key], after?.[key]));
}
